import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import {
  getDetailSegment,
  getHeaderTUDF,
  getValueAccountStatus,
  getValueAccountType,
  getValueAmountOwed,
  getValueDateAccountClosed,
  getValueDefaultDate,
  getValueInstallmentAmount,
  getValueNumberOfDate,
  getValuePaidDateLatest,
  getValuePastDue,
} from "../../../utils/buro";
import { Button } from "../layer/wrapper";
import { format, differenceInDays } from "date-fns";
import _ from "lodash";
import FileSaver from "file-saver";
import {
  reinstallments,
  calcuratorInterestTwo,
} from "../../../utils/reinstallments";
import { API } from "aws-amplify";
import { getFilterLoanBuro } from "../BuroMainTwo";
import iconv from "iconv-lite";
import { calReportAging } from "../../../utils/calReportAging";
import ReactExport from "react-data-export";
import { pad } from "utils/getLocalDateTime";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

// const iconv = require("iconv-lite");

function ExportFixedBuro({
  loan = [],
  buroDate = new Date(),
  interest,
  defaultBuroList = [],
}) {
  const [loadingExport, setLoadingExport] = useState(false);
  const [error, setError] = useState(null);
  const [dataCsv, setDataCsv] = useState("");
  const [countExport, setCountExport] = useState(0);

  useEffect(() => {
    try {
      if (dataCsv) {
        // const docCsvLink = document.getElementById("csvLink");
        // docCsvLink.click();
        const filename = `TUCRS-MHS-${format(
          new Date(buroDate),
          "yyyy-MM"
        )}.csv`;

        const buffer = iconv.encode(dataCsv, "874");
        const buroBlob = new Blob([buffer]);
        FileSaver.saveAs(buroBlob, filename);
      }
    } catch (error) {
      console.log("click error", error);
    }
  }, [dataCsv]);

  const onClickExportBuro = async () => {
    try {
      setLoadingExport(true);

      // let { dataPrinciple: newLoan } = calReportAging(loan, buroDate);

      let newLoan = loan;

      let filterLoan = _.cloneDeep(newLoan).filter((itemLoan) => {
        const diffDefaultDate = differenceInDays(
          new Date(buroDate),
          new Date(itemLoan.overdue_date)
        );
        return diffDefaultDate <= 1915; //มากกว่า 5ปี 90วัน
      });

      // console.log("buroDate", buroDate);
      // filterLoan = getFilterLoanBuro(filterLoan, buroDate, interest);

      // let dataExport = _.cloneDeep(
      //   [...filterLoan].filter(
      //     (loanItem) => String(loanItem?.loan_kbank_id) !== "400139072"
      //   )
      // );

      console.log("filterLoan", filterLoan);
      let dataExport = filterLoan;
      // const dataExport = getFilterLoanBuro(loan, buroDate, interest, true);
      // const dataExport = loan

      // console.log("dataExport", dataExport);
      // console.log("buroDate", buroDate);

      // let dataExport = _.cloneDeep(
      //   [...filterLoan].filter(
      //     (loanItem) => String(loanItem?.loan_kbank_id) !== "400139072"
      //   )
      // );

      // console.log("dataExport", dataExport)

      // const headerCsvs = [
      //   "MEMBER",
      //   "IDTYPE",
      //   "IDNUMBER",
      //   "ACCOUNTNUMBER",
      //   "ACCOUNTTYPE",
      //   "DEFAULTDATE",
      //   "DATEOFLASTDEBTRESTRUCTURING",
      //   "CLOSEDDATE",
      //   "LASTPAYMENTDATE",
      //   "LIMITAMOUNT",
      //   "AMOUNTOWED",
      //   "AMOUNTPASTDUE",
      //   "ACCOUNTSTATUS",
      //   "NUMBER_OF_DAY_PAST_DUE",
      //   "ASOFDATE",
      // ];
      let contentCsvs = [];
      // let headerCsvs = `"Member","IDType","IDNumber","DOB","FID","AccountNumber","AccountType","OwnershipIndicator","OpenedDate","AsOfDate","DateOfLastDebtRestructuring","ClosedDate","LastPaymentDate","LimitAmount","AmountOwed","AmountPastDue","AccountStatus","NumberOfDayPastDue","DefaultDate","New OpenedDate","New DefaultDate","New Date of Last Debt Restructuring","New ClosedDate","New LastPaymentDate","New LimitAmount","New AmountOwed","New AmountPastDue","New AccountStatus","New Number of Day Past Due","New AsOfDate"`;
      // let headerCsvs = `"New as of date","D number","ID type","Account number","Account type","Old account status","Old current balance","New account status","New current balance","Old Opened Date","Old Default Date","Old AsOfDate","Old DPD","Current Opened Date","Current Default Date","Current AsOfDate","Current DPD"`;
      // let headerCsvs = `"New as of date","D number","ID type","Account number","Account type","Old account status","Old current balance","New account status","New current balance","Old Opened Date","Old Default Date","Old AsOfDate","Old DPD","Current Opened Date","Current Default Date","Current AsOfDate","Current DPD"`;
      let headerCsvs = `"ShortName","id_type","id_number","AccountNo","AccountType","Installment Number of Payment","installment Frequency","Installment Amount","DefaultDate","Restructure Code","LastDebtRestDate","ClosedDate","LastPaymentDate","LimitAmount","AmountOwed","AmountPastDue","AccountStatus","NumberofDayPastDue","AsOfDate"`;
      headerCsvs = headerCsvs.split(",").map((item) => {
        return `${item}`.replace(/"/g, "");
      });
      // let content = header + `\n`;

      console.log("defaultBuroList", defaultBuroList);
      console.log("dataExport", dataExport);

      for (const exportItem of dataExport) {
        const [date, month, year] = exportItem.birthdateTh.split("/");

        const findDefaultBuro = defaultBuroList.find((item) => {
          const taxId = item[1];
          return String(taxId) === String(exportItem.citizenid);
        });

        console.log("findDefaultBuro", findDefaultBuro);
        console.log("exportItem", exportItem);

        //
        const diffOverDueDays = differenceInDays(
          new Date(buroDate),
          exportItem.overdue_date
        );
        let status = 20;
        if (diffOverDueDays > 90 && exportItem.overdue_date < "2024-01-01") {
          status = 21;
        }

        const items = [
          `"MHS"`,
          `"01"`,
          `"${exportItem?.citizenid}"`,
          `"${exportItem?.loan_kbank_id}"`,
          `"${findDefaultBuro[4]}"`,
          `"${exportItem?.period}"`,
          `"3"`,
          `"${getValueInstallmentAmount({
            data: exportItem,
            currentDate: buroDate,
          })}"`,
          `"${getValueDefaultDate({
            data: exportItem,
            currentDate: buroDate,
          })}"`,
          `""`,
          `"1900101"`,
          `"${getValueDateAccountClosed({
            data: exportItem,
            currentDate: buroDate,
          })}"`,
          `"${getValuePaidDateLatest({
            data: exportItem,
            currentDate: buroDate,
            formatDate: true,
          })}"`,
          `"${exportItem.requestamount}"`,
          `"${getValueAmountOwed({
            data: exportItem,
            currentDate: buroDate,
          })}"`,
          `"${getValuePastDue({
            data: exportItem,
            currentDate: buroDate,
          })}"`,
          `"${status}"`,
          `"${getValueNumberOfDate({
            data: exportItem,
            currentDate: buroDate,
          })}"`,
          `"2024-04-30"`,
          // `"${findDefaultBuro[1]}"`,
          // `"${findDefaultBuro[2]}"`,
          // `"${findDefaultBuro[3]}"`,
          // `"${findDefaultBuro[4]}"`,
          // `"${findDefaultBuro[5]}"`,
          // `"${findDefaultBuro[6]}"`,
          // `"${findDefaultBuro[7]}"`,
          // `"${findDefaultBuro[8]}"`,
          // `"${findDefaultBuro[9]}"`,
          // `"19900101"`,
          // `"${findDefaultBuro[11]}"`,
          // `"${findDefaultBuro[12]}"`,
          // `"${findDefaultBuro[13]}"`,
          // `"${findDefaultBuro[14]}"`,
          // `"${findDefaultBuro[15]}"`,
          // `"${findDefaultBuro[16]}"`,
          // `"${findDefaultBuro[17]}"`,
          // `"${findDefaultBuro[18]}"`,
          // `"${findDefaultBuro[19]}"`,
        ];

        // const items = [
        //   `"${findDefaultBuro[0]}"`,
        //   `"${findDefaultBuro[1]}"`,
        //   `"${findDefaultBuro[2]}"`,
        //   `"${findDefaultBuro[3]}"`,
        //   `"${findDefaultBuro[4]}"`,
        //   `"${findDefaultBuro[5]}"`,
        //   `"${findDefaultBuro[6]}"`,
        //   `"20"`,
        //   `"${findDefaultBuro[8]}"`,
        //   `"${findDefaultBuro[9]}"`,
        //   `"${findDefaultBuro[10]}"`,
        //   `"${findDefaultBuro[11]}"`,
        //   `"${findDefaultBuro[12]}"`,
        //   `"${findDefaultBuro[13]}"`,
        //   `"${findDefaultBuro[14]}"`,
        //   `"${findDefaultBuro[15]}"`,
        //   `"${findDefaultBuro[16]}"`,
        // ].map((item) => {
        //   return `${item}`.replace(/"/g, "");
        // });

        // const items = [
        //   '"MHS"',
        //   '"01"',
        //   `"${exportItem.citizenid}"`,
        //   `"${exportItem.loan_kbank_id}"`,
        //   `"${pad(getValueAccountType({ data: exportItem }))}"`,
        //   `"${getValueDefaultDate({ data: exportItem, currentDate: buroDate })}"`,
        //   `""`,
        //   `"${getValueDateAccountClosed({ data: exportItem })}"`,
        //   `"${getValuePaidDateLatest({ data: exportItem })}"`,
        //   `"${exportItem.requestamount}"`,
        //   `"${getValueAmountOwed({ data: exportItem, currentDate: buroDate })}"`,
        //   `"${getValuePastDue({ data: exportItem, currentDate: buroDate })}"`,
        // `"${getValueAccountStatus({
        //   data: exportItem,
        //   currentDate: buroDate,
        // })}"`,
        //   `""`,
        //   `"${format(new Date(buroDate), "yyyy-MM-dd")}"`,
        // ];

        // const items = [
        //   '"MHS"',
        //   '"01"',
        //   `"${findDefaultBuro[2]}"`,
        //   `"${findDefaultBuro[3]}"`,
        //   `"${findDefaultBuro[4]}"`,
        //   `"${findDefaultBuro[5]}"`,
        //   `"${findDefaultBuro[6]}"`,
        //   `"${findDefaultBuro[7]}"`,
        //   `"${findDefaultBuro[8]}"`,
        //   `"${findDefaultBuro[9]}"`,
        //   `"${findDefaultBuro[10]}"`,
        //   `"${findDefaultBuro[11]}"`,
        //   `"${findDefaultBuro[12]}"`,
        //   `"${findDefaultBuro[13]}"`,
        //   `"${findDefaultBuro[14]}"`,
        //   `"${findDefaultBuro[15]}"`,
        //   `"${findDefaultBuro[16]}"`,
        //   `"${findDefaultBuro[17]}"`,
        //   `"${findDefaultBuro[18]}"`,
        //   `"${findDefaultBuro[8]}"`,
        //   `"${getValueDefaultDate({ data: exportItem, currentDate: buroDate, formatDate: true })}"`,
        //   `"1900-01-01"`,
        //   `"${getValueDateAccountClosed({ data: exportItem, formatDate: true })}"`,
        //   `"${getValuePaidDateLatest({ data: exportItem, formatDate: true })}"`,
        //   `"${exportItem.requestamount}"`,
        //   `"${getValueAmountOwed({ data: exportItem, currentDate: buroDate })}"`,
        //   `"${getValuePastDue({ data: exportItem, currentDate: buroDate })}"`,
        //   `"${getValueAccountStatus({
        //     data: exportItem,
        //     currentDate: buroDate,
        //   })}"`,
        //   `"${getValueNumberOfDate({
        //     data: exportItem,
        //     currentDate: buroDate,
        //   })}"`,
        //   `"${format(new Date(buroDate), "yyyy-MM-dd")}"`,
        // ].map(item => {
        //   return `${item}`.replace(/"/g, "")
        // })
        contentCsvs.push(items);

        // let diffOverDueDays = differenceInDays(
        //   new Date(buroDate),
        //   exportItem.overdue_date
        //     ? new Date(exportItem.overdue_date)
        //     : new Date()
        // );

        // if (exportItem.loan_status === "DONE") {
        //   diffOverDueDays = 0;
        // }

        // content += `"MHS","01","${exportItem.citizenid}","${
        //   year - 543
        // }-${month}-${date}","FID","${
        //   exportItem.loan_kbank_id
        // }","05","1","${format(
        //   new Date(exportItem.requestTime),
        //   "yyyyMMdd"
        // )}","${format(
        //   new Date(buroDate),
        //   "yyyyMMdd"
        // )}","19000101","${getValueDateAccountClosed({
        //   data: exportItem,
        // })}","${getValuePaidDateLatest({ data: exportItem })}","${
        //   exportItem.capitalRemain
        // }","${getValueAmountOwed({
        //   data: exportItem,
        //   currentDate: buroDate,
        // })}","${getValuePastDue({
        //   data: exportItem,
        //   currentDate: buroDate,
        // })}","${getValueAccountStatus({
        //   data: exportItem,
        //   currentDate: buroDate,
        // })}","${diffOverDueDays}","${getValueDefaultDate({
        //   data: exportItem,
        //   currentDate: buroDate,
        // })}"\n`;
      }

      // console.log("headerCsvs", headerCsvs);

      let dataCsv = ``;
      let index = 0;

      // contentCsvs = contentCsvs.sort((a, b) => {
      //   return Number(a[12]) - Number(b[12]);
      // });

      contentCsvs = [headerCsvs, ...contentCsvs];

      console.log("contentCsvs", contentCsvs);

      for (const contentCsv of contentCsvs) {
        // if (Number(contentCsv[12]) !== 21) {
        //   index++;
        //   continue;
        // }
        dataCsv += `${contentCsv.join(",")}`;
        if (index !== contentCsvs.length - 1) {
          dataCsv += `\n`;
        }
        index++;
      }

      setCountExport(dataExport.length);
      setDataCsv(dataCsv);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingExport(false);
    }
  };

  return (
    <div>
      <Button
        onClick={onClickExportBuro}
        disabled={loadingExport || loan?.length === 0}
        loading={loadingExport}
      >
        Export Buro 10
      </Button>
      <CSVLink
        id="csvLink"
        hidden
        data={dataCsv}
        filename={`TUCRS-MHS-${format(new Date(buroDate), "yyyy-MM")}.csv`}
      />
    </div>
  );
}

export default ExportFixedBuro;
